/**
 * Route for `bulk-import-lost-orders`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BulkImportLostOrdersPage } from "../features/bulk-import-lost-orders/BulkImportLostOrdersPage";

export const bulkImportLostOrdersRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/bulk-import-lost-orders",
	component: BulkImportLostOrdersPage,
});

export default bulkImportLostOrdersRoute;
